module.exports = __webpack_public_path__ + "img/金属材料学5_2.e3740b8d.png";